
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('preferred_locale') ? localStorage.getItem('preferred_locale') : 'fr',
  messages: {
    en: require('./locales/en.json'),
    fr: require('./locales/fr.json')
  }
})
